import L10n, { setTranslations, DefaultProvider } from '@ews/react-localization-context';

import de from './de';
import en from './en';
import fr from './fr';
import hu from './hu';
import es from './es';
import cs from './cs';
import it from './it';
import sk from './sk';
import nl from './nl';
import pt from './pt';
import pl from './pl';
import no from './no';
import sh from './sh';
import hr from './hr';
import ru from './ru';
import sl from './sl';
import sv from './sv';
import tr from './tr';
import ro from './ro';
import fi from './fi';
import sr from './sr';
import da from './da';
import uk from './uk';
import et from './et';
import lt from './lt';
import kk from './kk';

import { setFallbackLocale, } from '@ews/react-localization-context/dist/DefaultProvider/DefaultProvider';

type LocaleKeys = keyof typeof en | keyof typeof de | Omit<string, keyof typeof en | keyof typeof de>;
export type Locale = string & LocaleKeys;
export { L10n };
export { DefaultProvider as L10nProvider };

export const localeTranslationKeys: Record<string, string> = {

    "de": "TD_DEUTSCH",
    "en": "TD_ENGLISCH",
    "fr": "TD_FRENCH",
    "hu": "TD_UNGARISCH",
    "es": "TD_SPANISCH",
    "cs": "TD_TSCHECHISCH",
    "it": "TD_ITALIENISCH",
    "sk": "TD_SLOWAKISCH",
    "nl": "TD_HOLLAENDISCH",
    "pt": "TD_PORTUGIESISCH",
    "pl": "TD_POLNISCH",
    "no": "TD_NORWEGISCH",
    "sh": "TD_BOSNISCH",
    "hr": "TD_KROATISCH",
    "ru": "TD_RUSSISCH",
    "sl": "TD_SLOWENISCH",
    "sv": "TD_SCHWEDISCH",
    "tr": "TD_TUERKISCH",
    "ro": "TD_RUMAENISCH",
    "fi": "TD_FINNISCH",
    "sr": "TD_SERBISCH",
    "da": "TD_DAENISCH",
    "uk": "TD_UKRAINISCH",
    "et": "TD_ESTNISCH",
    "lt": "TD_LITAUISCH",
    "kk": "TD_KASACHISCH"
};



export const Locales = {
    available: ["de", "en", "fr", "hu", "es", "cs", "it", "sk", "nl", "pt", "pl", "no", "sh", "hr", "ru", "sl", "sv", "tr", "ro", "fi", "sr", "da", "uk", "et", "lt", "kk"],
    default: 'de'
};

export const globalDebounceTime = 1000;

setTranslations({
    de, en, fr, hu, es, cs, it, sk, nl, pt, pl, no, sh, hr, ru, sl, sv, tr, ro, fi, sr, da, uk, et, lt, kk
});

setFallbackLocale("en");

export const localeRouteParam = `:locale(${Locales.available.join('|')})`;